let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("72a6H")).then(() => parcelRequire('iqyEd'));